import { render, staticRenderFns } from "./MultForm.vue?vue&type=template&id=b84b7044&scoped=true"
import script from "./MultForm.vue?vue&type=script&lang=js"
export * from "./MultForm.vue?vue&type=script&lang=js"
import style0 from "./MultForm.vue?vue&type=style&index=0&id=b84b7044&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84b7044",
  null
  
)

export default component.exports